import { render, staticRenderFns } from "./BookUpgrades.vue?vue&type=template&id=8630661c"
import script from "./BookUpgrades.vue?vue&type=script&lang=js"
export * from "./BookUpgrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports